module.exports = __webpack_public_path__ + "static/media/rps1.dfc7db6a.gif";